// public-site/src/components/Brand.js
// EB Garamond wordmark for the customer site. Single source of truth for the
// brand mark — to use a real logo image later, swap the wordmark <div> for an
// <img src="/sd-logo-white.png" .../> (drop the file in public-site/public/).

import React from 'react';
import { colors } from '../theme';

export default function Brand({ tagline }) {
  return (
    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
      <div
        style={{
          fontFamily: "'EB Garamond', Georgia, serif",
          fontSize: 'clamp(26px, 7vw, 38px)',
          fontWeight: 500,
          lineHeight: 1.15,
          color: colors.white,
          letterSpacing: '0.005em',
          maxWidth: '100%',
        }}
      >
        {'Stephenson‑Dearman'}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '14px',
          margin: '14px 0 0',
        }}
      >
        <span style={{ height: '1px', width: '38px', background: colors.hairline }} />
        <span
          style={{
            fontFamily: "'Host Grotesk', -apple-system, sans-serif",
            fontSize: 'clamp(11px, 3vw, 15px)',
            fontWeight: 600,
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: colors.gold,
          }}
        >
          Funeral Home
        </span>
        <span style={{ height: '1px', width: '38px', background: colors.hairline }} />
      </div>
      {tagline && (
        <div
          style={{
            fontFamily: "'Host Grotesk', -apple-system, sans-serif",
            fontSize: '16px',
            color: colors.textMuted,
            margin: '14px 0 0',
          }}
        >
          {tagline}
        </div>
      )}
    </div>
  );
}
